@import 'src/mixins';

.FadeScrollWrapper {
  flex: 1;
  min-height: 0;
  position: relative;
  overflow-y: auto;

  @media only screen and (min-width: 600px) {
    @include scrollbar();
  }

  .FadeScrollWrapper-shadow-top {
    pointer-events: none;
    position: sticky;
    top: 0;
    width: 100%;
    height: 30px;
    margin-bottom: -29px;
    background: linear-gradient(to top, rgba(99, 36, 198, 0) 7.5%, var(--color_neutral_0) 79%);
    transition: opacity 0.16s;
    z-index: 1;
    transform: translateY(-2px);
  }
  
  .FadeScrollWrapper-shadow-bottom {
    pointer-events: none;
    position: sticky;
    bottom: 0;
    width: 100%;
    height: 30px;
    margin-top: -29px;
    background: linear-gradient(to bottom, rgba(99, 36, 198, 0) 7.5%, var(--color_neutral_0) 79%);
    transition: opacity 0.16s;
    z-index: 1;
    transform: translateY(2px);
  }
}
